export const mobileSearchTriggerHeight = "6.4rem";
export const mobileSearchTriggerHeight = "6.4rem";
